export default __webpack_public_path__ + "static/media/milk.fb386a63.svg";